import SocialLinks from "components/social-links";
import HeartIcon from "lib/assets/svg/heart";
import { Link } from "react-router-dom";
import { domainName, Links, officeContactDetails } from "config/config";
import { KW_LOGO } from "constant";
import {
  COMPANY_NAME,
  COMPANY_URL,
  COPYRIGHT_SYMBOL,
  RIGHT_RESERVED,
  WEBSITE_NAME,
} from "constant/footerConst";
import { trackEvent, AnalyticsEvents } from "utils/analytics";
import { FEATURE_FLAGS } from "config/feature-flags";

const Footer = () => {
  return (
    <div
      className="lime-footer"
      style={{
        width: "100%",
        backgroundColor: "#CFD1E6",
        padding: "30px",
      }}
    >
      <section
        className="contact-details container pt-10 pb-10"
        style={{ padding: "30px 0" }}
        id="contact-details-section"
      >
        <div className="row text-center text-md-left">
          {/* Column 1: Logo & Contact Info */}
          <div className="col-12 col-sm-6 col-lg-3 grid-margin pb-3">
            <img
              src={KW_LOGO}
              alt="Kalyanawaran Matrimony"
              width={175}
              className="pb-2"
            />
            <div className="pt-2">
              <a
                className="text-muted m-0 d-block pb-1"
                style={{
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                href={`mailto:${officeContactDetails[0].emailId}`}
                onClick={() =>
                  trackEvent(AnalyticsEvents.CLICK, {
                    category: "contact",
                    label: "email",
                  })
                }
              >
                ✉️ {officeContactDetails[0].emailId}
              </a>
              <a
                className="text-muted m-0 d-block pt-1"
                style={{
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                href={`tel:${officeContactDetails[0].phone}`}
                onClick={() =>
                  trackEvent(AnalyticsEvents.CLICK, {
                    category: "contact",
                    label: "phone",
                  })
                }
              >
                📞 {officeContactDetails[0].phone}
              </a>
            </div>
          </div>

          {/* Column 2: Membership Plans */}
          <div
            className="col-12 col-sm-6 col-lg-2 grid-margin pb-3"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <h5 className="pb-2">Membership Plans</h5>
            <Link
              to={Links.plans}
              className="m-0 pb-2 text-primary"
              style={{ textDecoration: "none", fontWeight: 600 }}
            >
              Explore Plans
            </Link>
            <Link
              to={Links.plans}
              className="m-0 pt-1 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              ✨ Shubh Arambh (Silver)
            </Link>
            <Link
              to={Links.plans}
              className="m-0 pt-1 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              🌱 Free Plan
            </Link>
          </div>

          {/* Column 3: Legal & Policies (Terms & Conditions, Privacy Policy) */}
          <div
            className="col-12 col-sm-6 col-lg-2 grid-margin pb-3"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <h5 className="pb-2">Legal &amp; Policies</h5>
            <Link
              to={Links.terms}
              className="m-0 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              Terms &amp; Conditions
            </Link>
            <Link
              to={Links.privacy}
              className="m-0 pt-1 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              Privacy Policy
            </Link>
            <Link
              to={Links.cookie}
              className="m-0 pt-1 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              Cookie Policy
            </Link>
            {FEATURE_FLAGS.ENABLE_FAQ && (
              <Link
                to={Links.faq}
                className="m-0 pt-1 pb-2 text-primary"
                style={{ textDecoration: "none" }}
              >
                FAQ / Help
              </Link>
            )}
          </div>

          {/* Column 4: Guidelines & Tools */}
          <div
            className="col-12 col-sm-6 col-lg-3 grid-margin pb-3"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <h5 className="pb-2">Guidelines &amp; Tools</h5>
            <Link
              to={Links.gotralu}
              className="m-0 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              Gotralu
            </Link>
            <Link
              to={Links.nakshatraRashiList}
              className="m-0 pt-1 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              Nakshatra &amp; Rashi List
            </Link>
            <Link
              to={Links.socialGroups}
              className="m-0 pt-1 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              Social Groups
            </Link>
            <Link
              to={Links.ageDifferenceCalculator}
              className="m-0 pt-1 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              Age Difference Calculator
            </Link>
            <Link
              to={Links.ageCalculator}
              className="m-0 pt-1 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              Age Calculator
            </Link>
            <Link
              to={Links.blog}
              className="m-0 pt-1 pb-2 text-primary"
              style={{ textDecoration: "none" }}
            >
              Matrimony Blog
            </Link>
          </div>

          {/* Column 5: Our Address & Social Links */}
          <div className="col-12 col-sm-6 col-lg-2 grid-margin pb-3">
            <h5 className="pb-2">Our Address</h5>
            <p
              className="text-muted"
              style={{ fontSize: "14px", lineHeight: "1.5" }}
            >
              {officeContactDetails[0].addressFirstLine}
              <br />
              {officeContactDetails[0].city} - {officeContactDetails[0].pinCode}
              .
            </p>
            <SocialLinks />
          </div>
        </div>
      </section>
      <footer className="border-top">
        <p className="text-center text-muted pt-4">
          {COPYRIGHT_SYMBOL}
          <a
            href={domainName.fullLink}
            target="_blank"
            rel="noopener noreferrer"
            className="px-1"
          >
            {WEBSITE_NAME}.
          </a>
          {RIGHT_RESERVED}.
        </p>
        <p className="text-center text-muted pb-4">
          Made with <HeartIcon style={{ color: "red" }} /> by
          <a
            href={COMPANY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="px-1"
            onClick={() =>
              trackEvent(AnalyticsEvents.OUTBOUND_CLICK, {
                url: COMPANY_URL,
                type: "company_link",
              })
            }
          >
            {COMPANY_NAME}.
          </a>
        </p>
      </footer>
    </div>
  );
};

export default Footer;
